<template>
  <div class="section section4">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>智慧应用
      <!-- <a href="####" class="tit-more more-link c-blue">更多</a> -->
    </h2>
    <div class="subnav">
      <ul class="navbox">
        <li :class="{active: selected === 'yunjisuan'}">
          <a @click.prevent="onQueryData('yunjisuan')" href="####智慧住建" class="fs-rem28">
            智慧政务
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'cunchuyuCDN'}">
          <a @click.prevent="onQueryData('cunchuyuCDN')" href="####智慧社区" class="fs-rem28">
            智慧城市
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'zhihuichuxing'}">
          <a @click.prevent="onQueryData('zhihuichuxing')" href="####智慧出行" class="fs-rem28">
            智慧产业
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'yuming'}">
          <a @click.prevent="onQueryData('yuming')" href="####智慧健康" class="fs-rem28">
            中小企业赋能
            <i class="hr"></i>
          </a>
        </li>
        <li>
          <a href="####更多" class="c-blue fs-rem28" @click.prevent="$router.push('/service')">
            更多
            <i class="hr"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="w1200">
      <div class="sec4-list">

        <div class="list-box swiper-container swiperDigitCloud">
          <div class="swiper-wrapper" style="transition-duration: 0ms;">
            <div v-for="(item, index) in list" :key="item.rid" class="lst-item swiper-slide p-item"
              :data-swiper-slide-index="index">
              <a :href="item.url" class="">
                <div class="flex justify-center">
                  <img class="item-img" :src="formatImg(item.img)">
                </div>
                <div class="lst-txt">
                  <div class="c-gray-black fs-rem20 lst-tit line-limit-length">
                    {{item.title}}
                  </div>
                  <div class="c-gray-black fs-rem16 lst-date">
                    {{`发布时间:${formatT(item.createTime)}`}}
                  </div>
                  <div class="flex justify-between margin-lr margin-bottom">
                    <div class="c-blue-s">价格面议</div>
                    <div class="cu-tag line-blue" @click="window.location.href=item.url">详情</div>
                  </div>
                  <!-- <a :href="item.url" class="c-blue fs-rem26 lst-btn">查看详情</a> -->
                </div>
              </a>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
        <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide"></div>
        <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide"></div>
     </div>
    </div>
  </div>
  <!-- /数字上云 -->
</template>

<script>
  import {
    queryRecommendations
  } from '@/api/main';
  import {
    formatImgSrc
  } from '@/utils/format';
  import Swiper from 'swiper';
  import GetStaticIndexMixin from '@/mixins/GetStaticIndex.mixin.js'
  import {
    StaticIndexConfig
  } from '@/const/StaticIndexConfig.js'
  export default {
    mixins: [GetStaticIndexMixin],
    name: 'DigitizationCloud',
    props: {
      msg: String,
    },
    data() {
      return {
        list: [],
        selected: 'yunjisuan'
      }
    },
    mounted() {

    },
    methods: {
      p_init() {
        this.initData('shuzishangyun')
        new Swiper('.swiperDigitCloud', {
          loop: true,
          spaceBetween:10,
          slidesPerView: 'auto',
          initialSlide: 0,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
        this._queryRecommendations();
      },
      formatT(ts) {
        return this.formatTime(ts)
      },
      resetData() {
        this.list = [];
      },
      onQueryData(tid) {
        if (tid === 'more') {
          return;
        }
        this.resetData();
        this.selected = tid;
        this._queryRecommendations();
      },
      onGetPrice(item) {
        console.log(item, '立即报价');
      },
      formatImg(img) {
        return formatImgSrc(img)
      },
      formatData(list = []) {
        list.forEach(element => {
          element.img = formatImgSrc(element.img);
          return element;
        });
        return list;
      },
      _queryRecommendations() {
        // this.$http.get(queryRecommendations()).then((res) => {
        //   console.log(res, '>queryRecommendations ...');
        //   this.list = this.formatData(res.data);
        //   new Swiper('.swiperDigitCloud', {
        //     loop: true,
        //     slidesPerView: 4,
        //     initialSlide: 0,
        //     observer:true, //修改swiper自己或子元素时，自动初始化swiper
        //     observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //     navigation: {
        //       nextEl: '.swiper-button-next',
        //       prevEl: '.swiper-button-prev',
        //     },
        //   });
        // });
        this.list = this.StaticIndexs[this.selected];
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import url(./DigitizationCloud.css);
  @import url(../../mainui.css);

  .item-img {
    width: 150px;
    height: 150px;
    margin: 30px;
  }

  .p-item {
    background-color: #FFFFFF;
  }


</style>
